import type { ThunkDispatch } from 'editor/src/store/hooks';
import type { RootState } from 'editor/src/store/index';

import { ResolvedVariantPayload } from '../reducer/addResolvedVariantReducer';

import { findLocalVariation } from './lazyVariantOperations';
import sendSwitchProductOperation from './sendSwitchProductOperation';

/**
 * Completes the variant selection after successful resolution.
 * Triggers the product switch to update the design.
 */
const completeVariantResolutionOperation =
  (resolved: ResolvedVariantPayload) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const { product, selectedPageCount } = state.variants;

    const variation = findLocalVariation(product.productVariations, resolved.attributes);

    if (!variation) {
      return;
    }

    const variantInfo = {
      variation,
      dimensions: undefined,
      pageCount: selectedPageCount,
    };

    dispatch(sendSwitchProductOperation(variantInfo));
  };

export default completeVariantResolutionOperation;
